import http from './http';
import { prepareImageForUpload } from '../utils/prepareImageUpload';
import { isUploadWithinLimit, uploadLimitExceededMessage } from '../utils/uploadLimits';

export interface WidgetQueryParams {
  archived?: number;
  page?: number;
  limit?: number;
  [key: string]: any;
}

export const saveCdnWidget = async (customerId: string, data: any) => {
  return await http.post(`cdn/${customerId}`, data);
};

export const updateCdnWidget = async (widgetId: string, data: any, customerId?: string) => {
  return await http.put(`cdn/${customerId ? customerId + '/' : ''}${widgetId}`, data);
};

export const searchCdnWidget = async (params?: WidgetQueryParams, signal?: AbortSignal) => {
  return await http.get(`cdn`, params, {}, signal);
};

export const getCdnWidget = async (customerId: string, params?: WidgetQueryParams, signal?: AbortSignal) => {
  return await http.get(`cdn/${customerId}`, params, {}, signal);
};

export const getCdnWidgetByWidgetId = async (widgetId: string, customerId?: string) => {
  return await http.get(`cdn/widgets/${customerId ? customerId + '/' : ''}${widgetId}`);
};

export const removeCdnWidgetByWidgetId = async (widgetId: string, customerId?: string, password?: string) => {
  return await http.delete(`cdn/widgets/${customerId ? customerId + '/' : ''}${widgetId}`, { password });
};

export const recoverCdnWidgetByWidgetId = async (widgetId: string, customerId?: string) => {
  return await http.put(`cdn/${customerId ? customerId + '/' : ''}${widgetId}/recover`);
};

export const removeForeverCdnWidgetByWidgetId = async (
  widgetId: string,
  customerId?: string,
  password?: string
) => {
  // Server route is DELETE /cdn/widgets/:widget_id/forever — no customerId in the path.
  return await http.delete(
    `cdn/widgets/${widgetId}/forever`,
    password ? { password } : undefined
  );
};

export const duplicateCdnWidget = async (widgetId: string, payload: any) => {
  return await http.post(`cdn/widgets/${widgetId}`, payload);
};

export const uploadImage = async (file) => {
  // Over the limit: refuse with a message, never shrink — factsheets are printed.
  // Thrown like http.ts errors, so callers read it from `msg`.
  if (!isUploadWithinLimit(file)) {
    // eslint-disable-next-line no-throw-literal
    throw { msg: uploadLimitExceededMessage(file?.size) };
  }
  const prepared = await prepareImageForUpload(file);
  if (!isUploadWithinLimit(prepared)) {
    // eslint-disable-next-line no-throw-literal
    throw { msg: uploadLimitExceededMessage(prepared.size) };
  }
  const form: any = new FormData();
  form.append('image', prepared);
  return await http.post(`cdn/widgets/upload`, form);
};

export const getHistoryChartData = async (type, isin, mode, until) => {
  return await http.get(`cdn/widgets/history?type=${type}&isin=${isin}&mode=${mode}&until=${until}`);
};

export const getCdnWidgetByIsin = async (isin: string) => {
  return await http.get(`cdn/widgets/isin/${isin}`);
};
